module.exports = "\n<div>\n  <em>{{data.name}}</em>\n  <p>{{data.address}}</p>\n  <a (click)=\"goDetail(data.id)\">Ver servicio</a>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/tooltip/tooltip.html
// module id = ./src/app/common/tooltip/tooltip.html
// module chunks = main